// extracted by mini-css-extract-plugin
module.exports = {"bullet":"navigation__bullet___1dfQ6","horizontal":"navigation__horizontal___rum15","vertical":"navigation__vertical___1JH-2"};